import { useEffect, useState } from 'react';
import { apiErrorMessage } from '../../../../../shared/policies/api-error-message';
import { useToast } from '../../../../../shared/hooks/use-toast';
import { listJobAccessorialTerms, overrideJobAccessorialFreeQuantity, type JobAccessorialTerm } from '../../../jobs.api';

/** `null` while the first fetch is pending — a skeleton, not an empty table (CLAUDE.md → Loading states). */
export function useCommercialTerms(jobId: string) {
  const [terms, setTerms] = useState<JobAccessorialTerm[] | null>(null);
  const [overrideError, setOverrideError] = useState<string | null>(null);
  const toast = useToast();

  useEffect(() => {
    let cancelled = false;
    listJobAccessorialTerms(jobId)
      .then((loaded) => {
        if (!cancelled) setTerms(loaded);
      })
      .catch(() => {
        if (!cancelled) setTerms([]);
      });
    return () => {
      cancelled = true;
    };
  }, [jobId]);

  async function overrideFreeQuantity(accessorialTypeCode: string, accessorialTypeName: string, freeQuantity: number, reason: string): Promise<boolean> {
    setOverrideError(null);
    try {
      setTerms(await overrideJobAccessorialFreeQuantity(jobId, accessorialTypeCode, { freeQuantity, reason }));
      toast.success(`Free quantity for ${accessorialTypeName} updated`);
      return true;
    } catch (err) {
      setOverrideError(apiErrorMessage(err) ?? 'Could not save — the job may no longer be editable.');
      return false;
    }
  }

  return { terms, overrideError, overrideFreeQuantity };
}
